"use client";

import { createContext, useContext, type ReactNode } from "react";

/**
 * True while a block is being rendered for the downloaded lesson (LessonPrintDocument), not
 * for a learner to use.
 *
 * A printed page has no interaction, so a block that hides part of its content behind one — a
 * card to flip, a tab to open, a step to reveal — reads this and lays everything out at once,
 * in the same visual style as on screen. Blocks with nothing hidden ignore it.
 */
const LessonPrintModeContext = createContext(false);

export function LessonPrintModeProvider({ children }: { children: ReactNode }) {
  return <LessonPrintModeContext.Provider value>{children}</LessonPrintModeContext.Provider>;
}

export function useLessonPrintMode(): boolean {
  return useContext(LessonPrintModeContext);
}
